import * as React from 'react';
import { FormGroup } from '../../form/FormGroup';
import { FormInput } from '../../form/FormInput';
import { FormComponentProps } from '../../form/Form';
import { FormTransferContainer } from '../../form/FormTransferContainer';
import { SatelliteTicketsPanel } from './SatelliteTicketsPanel';
import { Validators } from '../../form/Validators';

const SATELLITE_TOURNAMENT_MODEL: string = 'satelliteConfiguration';
const CONFIGURATION_MODEL: string = 'configuration';

interface SatelliteTournamentPanelProps extends FormComponentProps {
    isPrivate: boolean;
}

export class SatelliteTournamentPanel extends React.Component<SatelliteTournamentPanelProps, {}> {
    getModel() {
        return this.props.fieldSet.getModelValue(SATELLITE_TOURNAMENT_MODEL);
    }

    getConfigurationModel() {
        return this.props.fieldSet.getModelValue(CONFIGURATION_MODEL);
    }

    render() {
        const satelliteConfiguration = this.getModel();
        const configuration = this.getConfigurationModel();
        const isTargetTournament =  satelliteConfiguration.isTarget;
        const isSatelliteTournament = configuration.dummyTournament ? false : satelliteConfiguration.isSatellite;
        const targetIsMustPlay = satelliteConfiguration.satellite.mustPlay;
        const isBountyTournament = configuration.hasBounty;
        const disabledIsSatelliteTournament = isBountyTournament || configuration.dummyTournament;
        const disabledMustPlay = configuration.satelliteToDummy;
        const disabledIsDummy = !(configuration.currency === 'XSD');

        return (
            <FormTransferContainer {...this.props}>
                <div className='row target-tournament-panel'>
                    <div className='col-lg-12'>
                        <div className='ibox float-e-margins'>
                            <div className='ibox-title'>
                                <h5>Satellite Tournaments</h5>
                            </div>
                            <div className='ibox-content'>
                                <FormGroup className='form-group'>
                                    <label className='col-sm-2 control-label'>Is Satellite</label>
                                    <div className='col-sm-10'>
                                        <FormInput type='checkbox' disabled={disabledIsSatelliteTournament} model='satelliteConfiguration.isSatellite'/>
                                    </div>
                                </FormGroup>
                                {isSatelliteTournament && <div>
                                    <div className='hr-line-dashed'></div>
                                    <FormGroup className='form-group'>
                                        <label className='col-sm-2 control-label'>Is satellite to Dummy</label>
                                        <div className='col-sm-10'>
                                            <FormInput type='checkbox' disabled={disabledIsDummy} model='configuration.satelliteToDummy'/>
                                            <span className='help-block m-b-none'>If checked, it would create a satellite tourney that has the dummy one as a target.</span>
                                        </div>
                                    </FormGroup>
                                    <div className='hr-line-dashed'></div>
                                    <FormGroup className='form-group'>
                                        <label className='col-sm-2 control-label'>Must play target right away</label>
                                        <div className='col-sm-10'>
                                            <FormInput type='checkbox' disabled={disabledMustPlay} model='satelliteConfiguration.satellite.mustPlay'/>
                                            <span className='help-block m-b-none'>If checked, upon been awarded the ticket, player has to play in next run of target tournament otherwise, ticket will expire</span>
                                        </div>
                                    </FormGroup>
                                    {targetIsMustPlay && <div>
                                        <div className='hr-line-dashed'></div>
                                        <FormGroup className='form-group'>
                                            <label className='col-sm-2 control-label'>Prevent registration when registered to target</label>
                                            <div className='col-sm-10'>
                                                <FormInput type='checkbox' model='satelliteConfiguration.satellite.preventRegistrationIfRegisteredToTarget' />
                                                <span className='help-block m-b-none'>If checked, the player will be barred from registering to this satellite if they are already registered for the target.</span>
                                            </div>
                                        </FormGroup>
                                    </div>}
                                    <div className='hr-line-dashed'></div>
                                    <FormGroup className='form-group'>
                                        <label className='col-sm-2 control-label'>Return Amount</label>
                                        <div className='col-sm-10'>
                                            <FormInput type='text' model='satelliteConfiguration.satellite.returnAmount'
                                                       className='form-control' validators={[Validators.required(), Validators.min(0.01)]} />
                                            <span className='help-block m-b-none'>Must be non-zero value. Defines how what's left in tournament prize pool will be awarded to runner ups who did not get ticket</span>
                                        </div>
                                    </FormGroup>
                                    <div className='hr-line-dashed'></div>
                                    <SatelliteTicketsPanel label='Awards Ticket' model='satelliteConfiguration.satellite.tickets'
                                                           singleTicket={true}/>
                                </div>}
                            </div>
                            {!this.props.isPrivate && <div className='ibox-content'>
                                <FormGroup className='form-group'>
                                    <label className='col-sm-2 control-label'>Is Target</label>
                                    <div className='col-sm-10'>
                                        <FormInput type='checkbox' model='satelliteConfiguration.isTarget'/>
                                    </div>
                                </FormGroup>
                                {isTargetTournament && <div>
                                    <div className='hr-line-dashed'></div>
                                    <FormGroup className='form-group'>
                                        <label className='col-sm-2 control-label'>Is dummy</label>
                                        <div className='col-sm-10'>
                                            <FormInput type='checkbox' disabled={disabledIsDummy} model='configuration.dummyTournament' />
                                            <span className='help-block m-b-none'>If checked, the tournament would be created as Dummy tournament.</span>
                                        </div>
                                    </FormGroup>
                                    <div className='hr-line-dashed'></div>
                                    <FormGroup className='form-group'>
                                        <label className='col-sm-2 control-label'>Allows direct Buy In</label>
                                        <div className='col-sm-10'>
                                            <FormInput type='checkbox' model='satelliteConfiguration.target.allowsDirectBuyIn'/>
                                        </div>
                                        <span className='help-block m-b-none'>If checked, this Target Tournament will allow players without ticket to register by paying Buy In Fee.</span>
                                    </FormGroup>
                                    <div className='hr-line-dashed'></div>
                                    <SatelliteTicketsPanel label='Accepts Tickets' model='satelliteConfiguration.target.tickets'
                                                           singleTicket={false}/>
                                </div>}
                            </div>}
                        </div>
                    </div>
                </div>
            </FormTransferContainer>
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/ui/poker/tournament/SatelliteTournamentPanel.tsx